module.exports = __webpack_public_path__ + "img/Loviisan-Aitta-nega-logo.119b16dd.png";